import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { auth, getApiError } from '../api/client';
import { useAuth } from '../contexts/AuthContext';
import Modal from './common/Modal';
import Input from './common/Input';
import Button from './common/Button';

// Self-service password change, reachable from the account button in the sidebar.
export default function ChangePasswordModal({ open, onClose }) {
  const { login } = useAuth();
  const [form, setForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const close = () => {
    setForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.newPassword.length < 8) { toast.error('Fjalëkalimi i ri duhet të ketë së paku 8 karaktere.'); return; }
    if (form.newPassword !== form.confirmPassword) { toast.error('Fjalëkalimet nuk përputhen.'); return; }
    setLoading(true);
    try {
      const res = await auth.changePassword({ currentPassword: form.currentPassword, newPassword: form.newPassword });
      login(res.data);
      toast.success('Fjalëkalimi u ndryshua me sukses.');
      close();
    } catch (err) {
      toast.error(getApiError(err, 'Gabim gjatë ndryshimit të fjalëkalimit.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={close} title="Ndrysho fjalëkalimin" width={440}>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <Input label="Fjalëkalimi aktual" type="password" value={form.currentPassword} onChange={set('currentPassword')} required placeholder="••••••••" />
        <Input label="Fjalëkalimi i ri" type="password" value={form.newPassword} onChange={set('newPassword')} required placeholder="Min. 8 karaktere" />
        <Input label="Konfirmo fjalëkalimin e ri" type="password" value={form.confirmPassword} onChange={set('confirmPassword')} required placeholder="Përsërite fjalëkalimin" />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button type="button" variant="ghost" onClick={close}>Anulo</Button>
          <Button type="submit" loading={loading}>Ruaj fjalëkalimin</Button>
        </div>
      </form>
    </Modal>
  );
}
